import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ThemeProvider } from 'next-themes';

import { NextUIProvider } from '@nextui-org/react';
import {UserProvider} from "./components/Private/UserProvider";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
    <NextUIProvider>
        <UserProvider>
          <ThemeProvider attribute="class" defaultTheme="dark">
            <App />
          </ThemeProvider>
        </UserProvider>
    </NextUIProvider>
  //</React.StrictMode>
);
